module.exports = __webpack_public_path__ + "static/photo-9-75e4e1764cab36926c9ba3a6f6c91d8e.jpg";